<template>
  <div class="h-full relative">
    <div
      v-if="isVisible"
      class="absolute h-full w-full flex flex-wrap top-0 left-0 overflow-hidden z-40"
    >
      <div class="w-1/2 shadow-lg" :style="{ backgroundColor: bgColor }">
        <div class="flex justify-between px-12 mt-4">
          <RandomText class="text-6xl"></RandomText>
          <div
            @click="infoShow"
            class="flex justify-end cursor-pointer creu-in"
          >
            <Icon icon="iwwa:close" width="55px" weight="light" />
          </div>
        </div>

        <fidelio-process
          :process="process"
          :processInfo="processInfo"
        ></fidelio-process>
      </div>
      <div class="w-1/2 opacity-60" :style="{ backgroundColor: bgColor }">
        <div
          class="w-full h-full opacity-20"
          :style="{ backgroundColor: bgColor }"
        ></div>
      </div>
    </div>
    <div class="flex flex-col h-full justify-between">
      <div class="flex justify-between">
        <div class="flex z-50 items-end p-4">
          <RandomText class="text-3xl">Sense</RandomText>
          <RandomText class="text-xl text-gray-400 pl-1"
            >Web developer</RandomText
          >
        </div>
      </div>
      <div>
        <RandomText class="cursor-pointer text-3xl p-5" @click="processShow"
          >Process</RandomText
        >
      </div>
    </div>

    <slider-projects :slides="slides" />
  </div>
</template>

<script>
import SliderProjects from "@/components/SliderProjects.vue";
import FidelioProcess from "@/components/FidelioProcess.vue";
import RandomText from "@/components/RandomText.vue";

export default {
  name: "App",
  components: {
    SliderProjects,
    FidelioProcess,
    RandomText,
  },
  props: {
    bgColor: {
      type: String,
      required: true,
      default: "rgb(255, 255, 255)",
    },
  },
  data() {
    return {
      isVisible: false,
      slides: [
        {
          type: "text",
          content:
            "SENSE és el projecte final de l'assignatura de tercer de carrera: Projecte transmèdia. Aquest treball té com a finalitat conscienciar del sexe i tot el que l'envolta dins de la societat. A partir d'això volíem poder arribar a normalitzar aquest tema, donar tota la informació necessària sobre el sexe i de totes aquelles situacions i experiències de les quals no se solen parlar. La nostra meta era poder arribar a trencar tabús.",
        },
        {
          type: "image",
          content: "/img/sense/sense1.png",
        },
        {
          type: "image",
          content: "/img/sense/sense2.png",
        },
        {
          type: "image",
          content: "/img/sense/sense3.png",
        },
        {
          type: "image",
          content: "/img/sense/sense4.png",
        },
        {
          type: "image",
          content: "/img/sense/sense5.png",
        },
        {
          type: "image",
          content: "/img/sense/sense6.png",
        },
        {
          type: "image",
          content: "/img/sense/sense7.png",
        },
      ],
      process: [
        {
          text: "La pàgina web és el suport digital amb més presència. En aquest es tracten tots els temes dels catàlegs d'una forma més extensa i on s'accentua el contingut audiovisual, es mostren fotografies i vídeos realitzats. També es poden trobar enllaços externs que ajuden a completar la informació, a part de poder fer preguntes anònimes i personals a experts.",
        },
        {
          text: "El desenvolupament de la pàgina web es va dur a terme amb HTML, CSS i JS, i es va utilitzar Vue.js per a la seva creació. El projecte volia trencar amb els tabús del sexe, així que la pàgina web també havia de projectar la mateixa idea, és per això que intentem que el disseny no fos convencional. Vam fer que la pàgina web tingués el scroll horitzontal i que els usuaris poguessin interactuar de diferents maneres.",
        },
      ],
      processInfo: [
        {
          title: "Client:",
          subtitle: "Glyndebourne Productions Ltd.",
        },
        {
          title: "Location:",
          subtitle: "Glyndebourne Opera House",
        },
        {
          title: "Direction:",
          subtitle: "Frederic Wake-Walker",
        },
        {
          title: "Scenography and costumes:",
          subtitle: "Anna Jones",
        },
        {
          title: "Lighting:",
          subtitle: "Peter Mumford",
        },
        {
          title: "Video:",
          subtitle: "FRAY",
        },
        {
          title: "Photography:",
          subtitle: "Richard Hubert Smith, James Bellorini, Peter Mumford",
        },
      ],
    };
  },
  methods: {
    processShow() {
      this.isVisible = !this.isVisible;
    },
    infoShow() {
      this.isVisible = !this.isVisible;
    },
  },
};
</script>

<style>
.creu-in {
  animation: fadeInOut 5s ease-in-out infinite;
}

@keyframes fadeInOut {
  0% {
    transform: translateY(0) scale(0.7);
    opacity: 100%;
  }
  50% {
    transform: translateY(90vh) scale(0.2);
    opacity: 0%;
  }
  100% {
    transform: translateY(0) scale(0.7);
    opacity: 100%;
  }
}
</style>

